<template>
    <!-- :title="'x:' + Math.floor(field.region.x) + ',y:' + Math.floor(field.region.y) + ',w:' + Math.floor(field.region.w) + ',h:' + Math.floor(field.region.h) + ',rx:' + Math.floor(field.region.rx) + ',ry:' + Math.floor(field.region.ry) + ',rw:' + Math.floor(field.region.rw) + ',rh:' + Math.floor(field.region.rh)" -->
    <vue-drag-resize  ref="region" :id="this.field.id" :preventActiveBehavior="true" :isActive="field.selected" @activated="activated" @deactivated="deactivated" :key="field.id" @clicked="select" :minw="5" :minh="5" :z="zIndex" v-on:resizing="onDragResize" v-on:dragging="onDragResize" :x="field.region.x" :y="field.region.y" :w="field.region.w" :h="field.region.h">
      <div :id="'if' + this.field.id" :path="this.field.path" @contextmenu="contextmenu" ref="hitArea" v-bind:class="{'invoiceField':true, 'invoiceFieldSelected':field.selected, 'transparent':!field.rect || croping || creatingDoc, 'outline':field.rectOut }"
        :style="'width:100%; height:100%; background-color: rgba(' + field.region.rgba.r + ',' + field.region.rgba.g + ',' + field.region.rgba.b + ',' + field.region.rgba.a + ');' + (field.rectOut ? 'box-shadow: 0px 0px 0px 4px ' + 'rgba(' + field.region.rgba.r + ',' + field.region.rgba.g + ',' + field.region.rgba.b + ',' + field.region.rgba.a + ')' : '') "></div>
      <!-- <div :id="'if' + this.field.id" :path="this.field.path" @contextmenu="contextmenu" ref="hitArea" v-bind:class="{'invoiceField':true, 'invoiceFieldSelected':field.selected}" :style="'width:100%; height:100%; background-color:' + (field.rect) ? field.color : '#000' + '; border: ' + (field.rectOut) ? '4' : '0' + 'px solid ' + field.colorBorder + ';'"></div> -->
      <v-menu v-model="menu" absolute :close-on-content-click="false" :position-x="menuX" :position-y="menuY" offset-y>
        <v-list>
          <v-list-item @click="onContextAction('delete')">
            <v-list-item-icon><v-icon>mdi-delete-sweep</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t("editor.dropmenu_remove") }}</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item @click="onContextAction('color')">
            <v-list-item-icon><v-icon>mdi-palette</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t("editor.dropmenu_color") }}</v-list-item-title>
          </v-list-item> -->
          <v-list-item v-show="!crop && !createDoc" @click="field.rect = !field.rect; field.rectOut = false; field.crop = false">
            <v-list-item-action>
              <v-checkbox v-model="field.rect" readonly></v-checkbox>
            </v-list-item-action>
            <v-list-item-title>{{ $t("editor.dropmenu_redact") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-show="!crop && !createDoc" @click="field.rectOut = !field.rectOut; field.crop = false; field.rect = false">
            <v-list-item-action>
              <v-checkbox v-model="field.rectOut" readonly></v-checkbox>
            </v-list-item-action>
            <v-list-item-title>{{ $t("editor.dropmenu_outline") }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-color-picker v-show="!crop && !createDoc" v-model="field.region.rgba" :hide-canvas="false" dot-size="15" mode="rgba" swatches-max-height="198" @update:color="onUpdateColor"></v-color-picker>
      </v-menu>
    </vue-drag-resize>
</template>

<script>
import VueDragResize from 'vue-drag-resize'

export default {
  name: 'region',
  props: ['field', 'image', 'crop', 'createDoc', 'batchTypes'],
  components: { VueDragResize },
  data () {
    return {
      isResizable: false,
      menu: false,
      menuX: 0,
      menuY: 0,
      croping: false,
      creatingDoc: false
    }
  },
  computed: {
    state () { return this.$store.state },
    selectedField: {
      get () { return this.state.selectedField },
      set (val) { this.state.selectedField = val }
    },
    context () { return this.state.context },
    zIndex () {
      return (this.selectedField.id === this.field.id) ? 100 : 0
    },
    selected () {
      return this.field.selected
    }
  },
  methods: {
    onUpdateColor (c) {
      // console.log('onUpdate Color:', c)
      this.batchTypes.General.rgba = c.rgba
      if (this.batchTypes.Current.ApplicationSettings.ExportSettings.Depth === 'BlackWhite') {
        this.batchTypes.General.rgba.a = 1
        this.field.region.rgba.a = 1
      }
    },
    onContextAction (a) {
      if (a === 'delete') {
        const index = this.image.Fields.indexOf(this.field)
        this.image.Fields.splice(index, 1)
      }
      if (a === 'color') { }
    },
    activated (ev) {
      console.log('activated', this.field.selected, this.field)
      if (!this.field.selected) return
      console.log('activated')
    },
    deactivated (ev) {
      console.log('deactivated')
    },
    contextmenuDrag (ev) {
      console.log('context menu drag')
    },
    contextmenuStick (ev) {
      ev.preventDefault()
      // let id = $(ev.target.parentElement).attr('id')
      // if (parseInt(id) !== this.field.id) return
      this.contextmenu(ev)
    },
    mouseDownStick (ev) {
      ev.preventDefault()
      // let id = $(ev.target.parentElement).attr('id')
      // if (parseInt(id) !== this.field.id) return
      // console.log('mouseDownStick', this.$refs.hitArea)
      // let hitArea = this.$refs.hitArea
      // hitArea.click()
      // $('#if' + this.field.id).trigger('click')
      this.select(null)
    },
    contextmenu (ev) {
      console.log('context menu')
      ev.preventDefault()
      this.select(null)
      this.menuX = ev.clientX
      this.menuY = ev.clientY
      this.menu = true
      // this.context.active = true
      // this.context.contextPosition.x = ev.clientX
      // this.context.contextPosition.y = ev.clientY
    },
    resizeField () {
      // console.log('resizeField()')
      const percentW = this.field.clientWidth / this.field.naturalWidth * 100
      const percentH = this.field.clientHeight / this.field.naturalHeight * 100
      // console.log('percent', percentW, percentH)
      /* const x = Math.round((percentW / 100) * this.field.region.rx)
      const y = Math.round((percentH / 100) * this.field.region.ry)
      const w = Math.round((percentW / 100) * this.field.region.rw)
      const h = Math.round((percentH / 100) * this.field.region.rh) */
      const x = (percentW / 100) * this.field.region.rx
      const y = (percentH / 100) * this.field.region.ry
      const w = (percentW / 100) * this.field.region.rw
      const h = (percentH / 100) * this.field.region.rh
      // console.log(x, y, w, h)
      this.field.region.x = x
      this.field.region.y = y
      this.field.region.w = w
      this.field.region.h = h
    },
    convertToRealSize () {
      // console.log('convertToRealSize')
      const pageWidth = this.field.region.naturalWidth
      const pageHeight = this.field.region.naturalHeight
      const x = (this.field.region.x / this.field.clientWidth * 100) * pageWidth / 100
      const y = (this.field.region.y / this.field.clientHeight * 100) * pageHeight / 100
      const w = (this.field.region.w / this.field.clientWidth * 100) * pageWidth / 100
      const h = (this.field.region.h / this.field.clientHeight * 100) * pageHeight / 100
      this.field.region.rx = x
      this.field.region.ry = y
      this.field.region.rw = w
      this.field.region.rh = h
    },
    select (ev) {
      console.log('select region...', this.field.id, ev)
      if (this.selectedField !== null) {
        this.selectedField.selected = false
      }
      this.selectedField = this.field
      this.field.selected = true
      this.activated()
    },
    mouseover (ev) {
      // console.log("mouseover:");
    },
    mouseout (ev) {
      // console.log("mouseout:");
    },
    onDragResize (rect) {
      this.field.region.x = rect.left
      this.field.region.y = rect.top
      this.field.region.w = rect.width
      this.field.region.h = rect.height
      // this.convertToRealSize()
    },
    onEditResize (data) {
      console.log('onEditResize', data)
      this.field.clientWidth = data.clientWidth
      this.field.clientHeight = data.clientHeight
      this.field.region.clientWidth = data.clientWidth
      this.field.region.clientHeight = data.clientHeight
      console.log(this.field.region)
      this.resizeField()
      // this.convertToRealSize()
    }
  },
  watch: {
    'field.selected': function (newVal, oldVal) {
      if (newVal === false) this.menu = false
    },
    'field.region.x': function (newVal, oldVal) {
      this.convertToRealSize()
    },
    'field.region.y': function (newVal, oldVal) {
      this.convertToRealSize()
    },
    'field.region.w': function (newVal, oldVal) {
      this.convertToRealSize()
    },
    'field.region.h': function (newVal, oldVal) {
      this.convertToRealSize()
    }
  },
  beforeDestroy () {
    this.menu = false
    console.log('Region beforeDestroy()')
    this.$root.$off('EDIT_RESIZE', this.onEditResize)
  },
  mounted () {
    if (this.state.selectedField !== null) {
      this.state.selectedField.selected = true
      if (this.field.selected) this.select(null)
    } else {
      if (this.field.selected) {
        this.state.selectedField = this.field
        this.state.selectedField.selected = true
        this.select(null)
      }
    }
  },
  created () {
    this.croping = this.crop
    this.creatingDoc = this.createDoc
    this.convertToRealSize()
    this.$root.$on('EDIT_RESIZE', this.onEditResize)
    // only for blackWhite Export
    if (this.batchTypes.Current.ApplicationSettings.ExportSettings.Depth === 'BlackWhite') {
      this.field.region.rgba.a = 1
    }
  }
}
</script>

<style scoped>
.invoiceField {
    /* width: 3px;
    height: 3px; */
    top: 0;
    background-color: rgba(0, 0, 0, 1);
    position: absolute;
    z-index: 0;
    cursor: default !important;
    box-sizing: border-box;
    pointer-events: all;
    opacity: 1;
    -webkit-box-shadow:inset 0px 0px 0px 1px #000;
    -moz-box-shadow:inset 0px 0px 0px 1px #000;
    box-shadow:inset 0px 0px 0px 1px #000;
    /* background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=);
    background-repeat: repeat-x repeat-y;
    background-size: 100% 100%; */
}

.invoiceField:hover {
  opacity: .3;
}

.transparent {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.outline {
  /* border: 4px solid #000; */
  -webkit-box-shadow:inset 0px 0px 0px 4px #000;
  -moz-box-shadow:inset 0px 0px 0px 4px #000;
  box-shadow:inset 0px 0px 0px 4px #000;
  background-color: transparent !important;
}

.invoiceFieldSelected {
    opacity: 1
}

.vdr-stickSmall {
    width: 6px !important;
    height: 6px !important;
    top: -3px !important;
    left: -3px !important;
}
</style>
